import { z } from 'zod';
import { provincesEnum, type Province } from './payor';

export const specialtySchema = z.object({
  province: provincesEnum.optional().default('MB'),
  code: z.string(),
  description: z.string().nullable(),
});

const anesthesiaSpecialtyCodeByProvince: Readonly<
  Record<string, string | undefined>
> = {
  MB: '10',
  BC: '18',
};

export const isAnesthesiaSpecialty = (
  province: Province | null | undefined,
  specialtyCode: string | null | undefined
): boolean =>
  anesthesiaSpecialtyCodeByProvince[province || 'MB'] === specialtyCode;
